module.exports = __webpack_public_path__ + "static/img/help_08book_02.490db3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_08book_02.png
// module id = 703
// module chunks = 140